// removed by extract-text-webpack-plugin
module.exports = {"infoIcon":"dalhwoKMS7UocmlMhzhXS","expirySoon":"kB2StdV9yzah2PU12yik0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/CoverageRecipientListItem/CoverageRecipientListItem.scss
// module id = 1324
// module chunks = 1